<a class="nav-link dropdown-toggle" (click)="(false)" href data-toggle="dropdown" dropdownToggle>
  {{ dropDownLabel }} <span class="caret"></span>
</a>
<ul *dropdownMenu class="dropdown-menu animation-on-widget-open-fadeIn" role="menu">
  <li role="menuitem" *ngFor="let currentBereich of arbeitsbereiche">
    <a class="dropdown-item" (click)="selectBereich(currentBereich)" translate>{{
      currentBereich.name
    }}</a>
  </li>
</ul>
